var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ZERO_WIDTH_SPACE } from '../consts.js';
import { getInlineEditorInsideRoot } from '../utils/query.js';
let VElement = class VElement extends LitElement {
    constructor() {
        super(...arguments);
        this.delta = {
            insert: ZERO_WIDTH_SPACE,
        };
    }
    render() {
        const inlineEditor = getInlineEditorInsideRoot(this);
        const attributeRenderer = inlineEditor.attributeService.attributeRenderer;
        const isEmbed = inlineEditor.isEmbed(this.delta);
        if (isEmbed) {
            if (this.delta.insert.length !== 1) {
                throw new Error(`The length of embed node should only be 1.
          This seems to be an internal issue with inline editor.
          Please go to https://github.com/toeverything/blocksuite/issues
          to report it.`);
            }
            return html `<span
        data-v-embed="true"
        data-v-element="true"
        contenteditable="false"
        style=${styleMap({ userSelect: 'none' })}
        >${attributeRenderer(this.delta, this.selected)}</span
      >`;
        }
        // we need to avoid \n appearing before and after the span element, which will
        // cause the unexpected space
        return html `<span data-v-element="true"
      >${attributeRenderer(this.delta, this.selected)}</span
    >`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], VElement.prototype, "delta", void 0);
__decorate([
    property({ attribute: false })
], VElement.prototype, "selected", void 0);
VElement = __decorate([
    customElement('v-element')
], VElement);
export { VElement };
//# sourceMappingURL=v-element.js.map